import { all, takeEvery } from "redux-saga/effects";
import { tocActionsConstants } from "@/store/actions/toc.actions";
import { _sharedWorkerFetchToc } from "@/shared/store/toc/saga";

export default function* tocSaga() {
  yield all([
    takeEvery(tocActionsConstants.FETCH, _sharedWorkerFetchToc),
  ]);
}
